<template>
  <v-menu open-on-hover right offset-x>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" @click="onClick" :block="block" :text="text" class="status" :small="small"
             :class="elementClass">{{ number }}
      </v-btn>
    </template>

    <v-list>
      <v-list-item>
        Статус: {{ statusText }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {GetStatusText,GetStatusVariant} from "@/enum/InvoiceStatus";


export default {
  name: "InvoiceStatus",
  props: {
    status: {
      type: Number,
      default: 0
    },
    number: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    block: {
      type: Boolean,
      default: true
    },
    text: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    followClick: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    elementClass() {
      return GetStatusVariant(this.status)
    },
    statusText() {
      return GetStatusText(this.status)
    }
  },
  methods: {
    onClick() {
      if (this.followClick)
        this.$router.push({name: 'invoice-page', params: {id: this.id}})
    }
  }
}
</script>

<style scoped>

</style>